import { LoggerOptions } from './logger';

export class AppConfig {
  webApiEndpoint: string;
  defaultPath: string;
  loggingOption: LoggerOptions;
}
